export default __webpack_public_path__ + "static/media/cargo-icon.26efd9bc.svg";